import io from "socket.io-client";
import { server } from './keys.js';
let token = localStorage.getItem('token');
export const socket = io(server, {
  transports: ['websocket'],
  rejectUnauthorized: false,
  query: `token=${token}`
});